
<div class="row">
    <div class="col-12">
        <div class="d-flex gap-5" style="align-items: center;" *ngIf="(materializeAgent.plate$ | async) as plate else noPlateTmpl">
            <app-error-text *ngIf="plate.state === 'disconnected'">Plateforme déconnectée</app-error-text>
            <app-error-text *ngIf="plate.state === 'unavailable'">Plateforme indisponible</app-error-text>
            <app-error-text *ngIf="plate.summary.licensed !== 'yes'">Aucune licence pour le scanner</app-error-text>
            <app-button iconName="player-play-filled" tooltip="Démarrer l'enregistrement" (clickEvent)="startMaterializeRecording()" [disabled]="plate.state !== 'ready'"></app-button>
            <app-button iconName="player-stop-filled" tooltip="Arrêter l'enregistrement" (clickEvent)="stopMaterializeRecording()" [disabled]="plate.state !== 'measuring'"></app-button>
            <app-button iconName="rotate-clockwise-2" (clickEvent)="rotationChanged()" [disabled]="(materializeAgent.plate$ | async)?.state !== 'measuring'"></app-button>
            <ng-container *ngIf="recordingDuration > 0">
                {{recordingDuration}}{{recordingDuration === 1 ? ' seconde' : ' secondes'}}
            </ng-container>
        </div>
        <ng-template #noPlateTmpl>
            <div class="d-flex gap-5" *ngIf="materializeAgent.socketOnError$ | async else noPlatePlateTmpl">
                <app-error-text message="Veuillez démarrer l'agent RS Scan ou contacter le support"></app-error-text>
                <span class="cursor-pointer link" (click)="materializeAgent.connect()">Se reconnecter à l'agent</span>

            </div>
            </ng-template>
        <ng-template #noPlatePlateTmpl>
            <div class="d-flex gap-5" *ngIf="(materializeAgent.connected$ | async) === true && (this.materializeAgent.plateLoading$ | async) === false">
                <app-error-text message="Veuillez brancher la plateforme"></app-error-text>
                <span class="cursor-pointer link" (click)="materializeAgent.refreshPlate()">Se reconnecter à la plateforme</span>
            </div>
        </ng-template>
    </div>
</div>
<div class="row">
    <div class="col-12 text-center" *ngIf="(materializeAgent.plate$ | async)?.state === 'measuring'">
        <app-loading  text="Captation en cours"></app-loading>
    </div>
</div>
<div class="row">
    <div class="col-12 col-lg-10 col-xl-9" style="text-align: center;">
        <h5>Empreinte</h5>
        <app-sticky-container *ngIf="refreshStaticResultInProgress">
            <app-loading  text="Calcul en cours"></app-loading>
        </app-sticky-container>
        <canvas style="border: 1px solid black; max-width: 100%; max-height: 60vh;" #canvas width="500" height="500"></canvas>
    </div>
    <div class="col-12 col-lg-2 col-xl-3" style="text-align: center;">
        <h5>Analyse</h5>
        <ng-container *ngIf="pressureLocation">
            <div class="d-flex w-100 m-y-12" style="border: 1px solid black;">
                <div class="text-center flex-grow-1">
                    <h1>Gauche</h1>
                    <h5>{{(pressureLocation.topLeft + pressureLocation.bottomLeft) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="border-left: 1px solid black">
                    <h1>Droite</h1>
                    <h5>{{(pressureLocation.topRight + pressureLocation.bottomRight) | number:'1.2-2'}} %</h5>
                </div>
            </div>
            <div class="d-flex w-100 m-y-12 flex-col" style="border: 1px solid black;">
                <div class="text-center flex-grow-1">
                    <h1>Avant</h1>
                    <h5>{{(pressureLocation.top) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="border-top: 1px solid black">
                    <h1>Arrière</h1>
                    <h5>{{(pressureLocation.bottom) | number:'1.2-2'}} %</h5>
                </div>
            </div>
            <div class="d-flex w-100 m-y-12 flex-wrap" style="border: 1px solid black;">
                <div class="text-center flex-grow-1" style="flex-basis: 50%; border-bottom: 1px solid black;">
                    <h1>Q1</h1>
                    <h5>{{(pressureLocation.topLeft) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="flex-basis: 50%; border-left: 1px solid black; border-bottom: 1px solid black;">
                    <h1>Q2</h1>
                    <h5>{{(pressureLocation.topRight) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="flex-basis: 50%;">
                    <h1>Q3</h1>
                    <h5>{{(pressureLocation.bottomLeft) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="flex-basis: 50%; border-left: 1px solid black;">
                    <h1>Q4</h1>
                    <h5>{{(pressureLocation.bottomRight) | number:'1.2-2'}} %</h5>
                </div>
            </div>
        </ng-container>
    </div>
</div>
